// extracted by mini-css-extract-plugin
module.exports = {"headLabel":"e_s-","title":"e_t-","subTitle":"e_u-","promoted":"e_v-"};